export const USER_DISPLAY_NAME_MAP: Record<string, string> = {
  'undefined undefined': 'System',
  'Bot Bot': 'Bot',
};

export const ACTIVITY_POLLING_INTERVAL_FOR_CLONE_JOB = 10_000;
